import {CustomEventHandler} from "../utils/CustomEventHandler";
import {CUSTOM_SCROLL, isIe11, isMobile, scrollSetting} from "../common/globalVars";
import {MathUtil} from "../utils/MathUtil";
import {HtmlUtil} from "../utils/HtmlUtil";
import {gsap} from "gsap";

export default class MotionKvVideo {
    constructor(triggerEl, motionEl, clipTop, clipBottom, outRatio, isReverse) {
        this.triggerEl = triggerEl;
        this.motionEl = motionEl;
        this.clipEl = motionEl.querySelector('.video-box');
        this.video = motionEl.querySelector('video');
        this.img = motionEl.querySelector('img');

        this.clipCurrentTop = this.clipTop = clipTop;
        this.clipCurrentBottom = this.clipBottom = clipBottom;
        this.isReverse = isReverse;
        this.outRatio = outRatio;
        this.init();
    }

    init() {
        this.addEvent();

        if (isIe11()) {
            let height = this.motionEl.getBoundingClientRect().height;
            this.video.style.marginTop = `${ height * (this.clipTop/100) * -1 }px`;
            this.clipEl.style.top = `${height * (this.clipTop/100)}px`;
            this.clipEl.style.height = `${height - (height * (this.clipBottom/100)) }px`;
        }
    }

    addEvent() {
        this.onResizeHandler();
        this.onScrollHandler({detail:0});
        CustomEventHandler.addHandler(window, 'resize', (e)=>this.onResizeHandler(e));
        CustomEventHandler.addHandler(window, CUSTOM_SCROLL, (e)=>this.onScrollHandler(e));
    }

    onScrollHandler(e) {
        let triggerTop = parseFloat(window.getComputedStyle(this.motionEl.parentNode.parentNode).top);
        let motionMargin = (window.innerHeight - parseFloat(window.getComputedStyle(this.motionEl).height))/2;
        let velocity = e.detail + motionMargin - triggerTop;

        let maxVelocity = HtmlUtil.getPos(this.triggerEl).y +
            parseFloat(window.getComputedStyle(this.triggerEl).height) -
            parseFloat(window.getComputedStyle(this.motionEl).height) - (motionMargin * 2);

        if (velocity>0) {
            if (velocity > maxVelocity) {
                velocity = maxVelocity;
            }
            if (scrollSetting.smooth) this.motionEl.style.transform = `translate3d(0, ${velocity}px, 0)`;
        }

        if (isIe11()) return;
        this.setClipPath(velocity, maxVelocity);
    }

    setClipPath (velocity, maxVelocity) {
        if ((this.clipTop + this.clipBottom) === 0) return;

        let clipPath;

        if (!isMobile(window.innerWidth)) {
            if (this.isReverse) {
                this.clipCurrentTop = MathUtil.map(velocity, maxVelocity * this.outRatio, maxVelocity, this.clipTop, 0);
            } else {
                this.clipCurrentTop = MathUtil.map(velocity, 0, maxVelocity, this.clipTop, 0, true);
                this.clipCurrentBottom = MathUtil.map(velocity, 0, (maxVelocity * this.outRatio), this.clipBottom, 100, true);
            }
        }

        clipPath = `inset(${this.clipCurrentTop}% 0 ${this.clipCurrentBottom}% 0)`;
        this.clipEl.style.clipPath = clipPath;
    }

    onResizeHandler() {
        this.motionEl.style.height = `${this.video.offsetHeight}px`;

        if (!scrollSetting.smooth) return;
        let y = gsap.getProperty(document.querySelector('main'), 'y');
        this.scrollTop = y*-1;
        this.onScrollHandler({detail:y*-1});
    }
}
